function matchInputDirective() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, ctrl, ngModel) {

            scope.$watch(attrs.bbMatchInput, () => {
                scope.val_1 = scope.$eval(attrs.bbMatchInput);
                return compare(ctrl.$viewValue);
            });

            const compare = function (value) {
                ctrl.$setValidity('match', scope.val_1 === value);
                return value;
            };

            ctrl.$parsers.push(compare);
        }
    };
}

angular
    .module('BB.inputs')
    .directive('bbMatchInput', matchInputDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/match-input/match_input.directive.js